module.exports = __webpack_public_path__ + "img/play.a5a493e8.svg";